<template>
  <div>
    <a-card size="small">
      <div slot="title">
        {{ $t("ujian.ujian-dashboard.question-category") }}
      </div>
      
    </a-card>
    
    <div class="boxKategori" v-for="item in itemKategori" :key="item.key">
        <a-row >
            <a-col :span="12">
                {{ item.name }}     
            </a-col>
            <a-col :span="12" style="text-align:right">
                <a-tag color="#2db7f5"> {{ item.number_of_questions }} </a-tag>
                <a-tag color="#87d068"> {{ item.number_of_answer }} </a-tag>
                <a-tag color="#f50"> {{ item.number_of_remain }} </a-tag>        
            </a-col>
        </a-row>
    </div>
    <div class="boxKategori" style="font-weight:bold">
        Keterangan
        <div>
            <a-tag color="#2db7f5"> Jml. Soal </a-tag> 
            <a-tag color="#87d068"> Jml. Jawab </a-tag>
            <a-tag color="#f50"> Jml. Sisa </a-tag> 
        </div>
    </div>
    
  
    <!-- <a-row v-for="item in itemKategori.list" :key="item.key" class="boxKategori">
      <a-col :span="12">
        {{ item.text }}     
      </a-col>
      <a-col :span="12" style="text-align:right">
        <a-tag color="#2db7f5"> {{ item.jmlSoal }} </a-tag>
        <a-tag color="#87d068"> {{ item.jmlJawab }} </a-tag>
        <a-tag color="#f50"> {{ item.jmlSisa }} </a-tag>        
      </a-col>
    </a-row>     -->
    <!-- <a-table :columns="columns" :data-source="itemKategori.list" bordered size="small"> </a-table> -->
  </div>
</template>
<script>
export default {
  props: ["itemKategori"],
  data() {
    return {
       styleBox:"boxKategori",
    };
  },
  methods:{
    
  },
  
};
</script>

<style >
.boxKategori {
  padding: 5px 5px;
  border-bottom: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-collapse: collapse;  
}
</style>